import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n";

export default {

    addClaim(subject, message , blNumber,blType, customerId,serviceId,serviceTypeId,page, pageSize){
        return axios.post('/api/claim/add', {id:null, subject: subject, message : message , blNumber:blNumber,blType:blType, customerId:customerId, serviceId:serviceId,serviceTypeId:serviceTypeId},{ params: {page: page, pageSize: pageSize} })
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("Réclamation envoyé avec succès");
                return response.data;
            } 
        })
        .catch(error => {
            Vue.prototype.$snotify.error(error);
            return Promise.reject(error);
        })

    },

    changeStatus(id, status,additionalNotes,page, pageSize){
         return axios.post('/api/claim/change-status', {itemId:id, status: status,additionalNotes:additionalNotes},{ params: {page: page, pageSize: pageSize} }) 
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("Etat de la réclamation est modifé");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error); throw error;})

    },
    
    changeService(id, serviceId,serviceTypeId,page, pageSize){
        return axios.post('/api/claim/change-service', {itemId:id, serviceId: serviceId, serviceTypeId: serviceTypeId},{ params: {page: page, pageSize: pageSize} }) 
       .then(response => {
           
           if (response && response.data) {
               Vue.prototype.$snotify.success("Service et type de la réclamation est modifé");
               return response.data;
           } 
       })
       .catch(error => {Vue.prototype.$snotify.error(error);})

   },
   changeAffectedUser(id, affectedUserId,page, pageSize){
        return axios.post('/api/claim/change-affected-user', {itemId:id,affectedUserId:affectedUserId },{ params: {page: page, pageSize: pageSize} }) 
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("Utilisateur affecté à la réclamation est modifé");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    changeClaimValid(id, isValidClaim,page, pageSize){
        return axios.post('/api/claim/change-not-valid', {itemId:id,isValidClaim:isValidClaim },{ params: {page: page, pageSize: pageSize} }) 
        .then(response => {
            
            if (response && response.data) {
                Vue.prototype.$snotify.success("La réclamation est modifée");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    changeBlNumber(id, blNumber,page, pageSize){
        return axios.post('/api/claim/change-blNumber', {itemId:id, blNumber: blNumber},{ params: {page: page, pageSize: pageSize} }) 
    .then(response => {
        
        if (response && response.data) {
            Vue.prototype.$snotify.success("Bon de Livraison de la réclamation est modifé");
            return response.data;
        } 
    })
    .catch(error => {Vue.prototype.$snotify.error(error); throw error;})
    },
    changeBlType(id, blType,page, pageSize){
        return axios.post('/api/claim/change-blType', {itemId:id, blType: blType},{ params: {page: page, pageSize: pageSize} }) 
    .then(response => {
        
        if (response && response.data) {
            Vue.prototype.$snotify.success("Type du Bon de Livraison de la réclamation est modifé");
            return response.data;
        } 
    })
    .catch(error => {Vue.prototype.$snotify.error(error); throw error;})
    },

    getClaims (page, pageSize,start,end,customerId, claimServiceId, claimStatus, dbId) {
        return axios.get('/api/claim/list', {params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId, claimServiceId:claimServiceId, claimStatus:claimStatus, dbAgencyId:dbId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
   
    exportClaims (page, pageSize, start, end, customerId, claimServiceId, claimStatus, dbId) {
        return axios.get('/api/claim/list', {
            params: {page: page, pageSize: pageSize, start: start, end: end, customerId: customerId, claimServiceId: claimServiceId, claimStatus: claimStatus, dbAgencyId: dbId},
            headers: {'Accept': 'text/csv'},
            responseType: 'blob'
        })
        .then(response => {
            const disposition = response.headers['content-disposition'] || '';
            const match = disposition.match(/filename="?([^";]+)"?/);
            const fileName = response.headers['filename'] || (match && match[1]) || 'claims_export.csv';
            const url = window.URL.createObjectURL(new Blob([response.data], {type: 'text/csv;charset=utf-8;'}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {Vue.prototype.$snotify.error(error); throw error;})
    },

    getClaimsServices (page, pageSize,serviceFilter,isServicePage) {
        return axios.get('/api/claim/services/list', { params: {page: page, pageSize: pageSize,serviceFilter:serviceFilter,isServicePage:isServicePage} })
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
            return [];

        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    updateServiceDefaultUser (page, pageSize,serviceId,defaultUserId) {
        return axios.put('/api/claim/services/save', {page: page, pageSize: pageSize,serviceId:serviceId,defaultUserId:defaultUserId})
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
            return [];

        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getServicesCount(){
        return axios.get('/api/claim/services/count')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getClaimHistory (claimId,page, pageSize) {
        return axios.get('/api/claim/history/list',{params:{claimId : claimId, page: page, pageSize: pageSize}})
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
            return [];

        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    sendContactUsMail (ContactUs) {
        return axios.post('/api/claim/contact-us', ContactUs)
        .then(response => {
            if (response && response.data) 
                {
                    Vue.prototype.$snotify.success(i18n.t('services.users.sendMailContactUs'))
                    return response.data

                }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },


    getClosedDetails (claimId) {
        return axios.get('/api/claim/closed/details',{params:{claimId : claimId}})
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
            return [];

        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },



}

